import getCategoryDetailsBreadcrumb from "./getCategoryDetailsBreadcrumb";

export default state => {
  const { breadcrumbs } = state.category;

  return breadcrumbs
    ? [...breadcrumbs.slice(0, -1), getCategoryDetailsBreadcrumb(state)]
    : [];
};
